import { render } from "./Programs.vue?vue&type=template&id=0c578350&scoped=true&ts=true"
import script from "./Programs.vue?vue&type=script&lang=ts"
export * from "./Programs.vue?vue&type=script&lang=ts"

import "./Programs.vue?vue&type=style&index=0&id=0c578350&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c578350"]])

export default __exports__